import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.98 3.66406L14.1206 10.0098C14.2456 10.3814 14.5948 10.6264 14.98 10.6328H21.77L16.2563 14.5273L16.2495 14.5322L16.2417 14.5381C16.0908 14.6531 15.9791 14.8121 15.9224 14.9932C15.8656 15.1746 15.8666 15.37 15.9253 15.5508L15.9263 15.5537L18.022 21.8682L12.52 17.9473L12.5132 17.9424L12.3901 17.8711C12.3053 17.8299 12.2148 17.8013 12.1216 17.7871L11.981 17.7764C11.7909 17.7764 11.6044 17.8347 11.4478 17.9424L11.4409 17.9473L6.02393 21.8076L8.09912 15.5537L8.1001 15.5508C8.15878 15.37 8.15976 15.1746 8.10303 14.9932C8.0463 14.8121 7.93462 14.6531 7.78369 14.5381L7.76807 14.5264L2.229 10.6309H9.03564L9.06006 10.6289C9.23562 10.6114 9.4025 10.5435 9.54053 10.4336C9.64412 10.3511 9.72829 10.2472 9.7876 10.1299L9.83838 10.0088L11.98 3.66406Z",
		stroke: "black"
	})
});
export default SvgStar;
